/** The shape of an operation map (03 §6, 04 §2.2). */

export const MAP = {
  /** Columns of choice before each keystone. */
  columns: 4,
  maxPerColumn: 3,
  /** Chance that a node with one onward link gets a second. */
  extraLinkChance: 0.45,
  /** Mission nodes per theatre, keystone excluded: `minMissionSlots` to `minMissionSlots + slotSpread - 1`. */
  minMissionSlots: 4,
  slotSpread: 3,
  /**
   * Most regular mission nodes in an operation. Each theatre can hold only its four native
   * archetypes once, so 12 native nodes of at most 17 + 3 keystones keeps the map 60 % native.
   */
  maxMissionSlots: 17,
  supportNodes: 2,
  thirdSupportChance: 0.4,
  depotCandidates: 3,
} as const;

/**
 * The threat ceiling that rises with progress (02 §12): the first column of the first theatre
 * is capped at `startCap` + the difficulty slider (3 on Standard), and the cap climbs evenly
 * until the last theatre's keystone, where even the heaviest archetype flies at its full rating.
 */
export const THREAT_RAMP = { startCap: 2 } as const;
